import { gql } from "@apollo/client";
import CHECKOUT_FRAGMENT from "@/fragments/checkout";

const CREATE_CHECKOUT_MUTATION = gql`
	${CHECKOUT_FRAGMENT}
	mutation CreateCheckout(
		$retailerId: ID!
		$address: CheckoutAddressInput
		$orderType: OrderType!
		$pricingType: PricingType!
		$metadata: JSON
	) {
		createCheckout(
			retailerId: $retailerId
			address: $address
			orderType: $orderType
			pricingType: $pricingType
			metadata: $metadata
		) {
			...checkoutFragment
		}
	}
`;
export default CREATE_CHECKOUT_MUTATION;
